export const INPUT_VALIDATION_ERROR_CODE = 'input-validation-error' as const;

export type InputValidationIssue = {
  code: string;
  path: string;
  message: string;
};

export type InputValidationErrorDetails = {
  type: typeof INPUT_VALIDATION_ERROR_CODE;
  method: string;
  issues: InputValidationIssue[];
};

type MeteorErrorLike = {
  error?: unknown;
  reason?: unknown;
  details?: unknown;
};

export type InputValidationMeteorError = MeteorErrorLike & {
  error: typeof INPUT_VALIDATION_ERROR_CODE;
  reason?: string;
  details?: string;
};

export function isInputValidationError(
  error: unknown,
): error is InputValidationMeteorError {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const errorWithCode: { error?: unknown } = error;
  return errorWithCode.error === INPUT_VALIDATION_ERROR_CODE;
}

export function parseInputValidationErrorDetails(
  error: InputValidationMeteorError,
): InputValidationErrorDetails | undefined {
  if (!error.details || typeof error.details !== 'string') {
    return undefined;
  }
  try {
    const parsed = JSON.parse(error.details);
    if (!parsed || typeof parsed !== 'object') {
      return undefined;
    }
    if (
      'type' in parsed &&
      parsed.type === INPUT_VALIDATION_ERROR_CODE &&
      'method' in parsed &&
      typeof parsed.method === 'string' &&
      'issues' in parsed &&
      Array.isArray(parsed.issues)
    ) {
      return parsed as InputValidationErrorDetails;
    }
    return undefined;
  } catch {
    return undefined;
  }
}
